import React, { useEffect, useState } from 'react'
import Datepicker from "react-tailwindcss-datepicker";
import { get } from '../../util/request';
import { useSelector } from 'react-redux';

const LaporanKerja = (props) => {
  const [value, setValue] = useState({
    startDate: null,
    endDate: null
  });

  const [state, setState] = useState({
    profile: '',
    loading: true,
    form: {
      company_id: '',
      employee_id: '',
      employee_name: '',
      employee_email: '',
      employee_nik: '',
      departement_id: '',
      phone_no: ''
    },
    projectList: '',
    sprintLogs: [],
    sprintLogLoading: false,
    selectedProject: '',
    selectedSprintLogs: '',
  })
  const jwtToken = useSelector(state => state.auth.generateToken)
  const user = useSelector(state => state.auth.user)

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      setState({
        ...state,
        loading: true
      })
      getProjectLists()

    }
    return () => isMounted === false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleValueChange = (newValue) => {
    console.log("newValue:", newValue);
    setValue(newValue);
  }

  const getProjectLists = (id) => {
    get(
      `public/api/v1/project-list?companyId=${user.company_id}`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        console.log(success.data.Data)
        setState(prevState => {
          return {
            ...prevState,
            // tasksList: success.data.Data,
            projectList: success.data.Data,
            loading: false
          }
        })
      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }
  const getSprintLogs = (id) => {
    get(
      `public/api/v1/sprint-log-list?companyId=1&companyProjectId=${id}`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        console.log(success.data.Data)
        setState(prevState => {
          return {
            ...prevState,
            // tasksList: success.data.Data,
            sprintLogs: success.data.Data,
            sprintLogLoading: false
          }
        })
      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const handleSelect = (e, name) => {
    setState(prevState => {
      return {
        ...prevState,
        // tasksList: success.data.Data,
        [name]: e.target.value,
        sprintLogLoading: true,
        selectedSprintLogs: ''
      }
    })
    getSprintLogs(e.target.value)

  }
  return (

    state.loading ? '' :
    <div className='w-full h-screen grid-cols-1 sm:grid-cols-2 bg-real-white'>
      <div className='w-full h-20 bg-real-white'>
        <div className='flex items-center h-full px-4'>
          <a href={process.env.PUBLIC_URL + "/home"}>
            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
          </a>
          <p className='px-4'>Laporan Kerja</p>
        </div>
      </div>
      <div className='w-full px-4 bg-real-white'>

        <div className='flex w-full h-full gap-2 py-2'>
          <Datepicker
            asSingle={true}
            useRange={false}
            placeholder={"Tanggal Izin"}
            primaryColor={"blue"}
            value={value}
            onChange={handleValueChange}
          />

        </div>
        <div className='w-full h-full py-2'>
          <select id="countries" value={state.selectedProject} onChange={(e) => handleSelect(e, 'selectedProject')} class="bg-white border border-bg-primary text-gray-900 text-sm rounded-lg focus:border-blue-500 block w-full p-4 dark:focus:border-blue-500">
            <option value={''}>Project Name</option>
            {state.projectList.map((item, index) => (
            <option key={index} value={item.company_project_id}>{item.company_project_name}</option>
            ))}
          </select>

        </div>
        <div className='w-full h-full py-2'>
          <select id="countries" value={state.selectedSprintLogs} class="bg-white border border-bg-primary text-gray-900 text-sm rounded-lg focus:border-blue-500 block w-full p-4 dark:focus:border-blue-500">
            <option value={''}>{state.sprintLogLoading ? 'Loading' : 'TC-Code'}</option>
            {state.sprintLogs?.map((item, index) => (
            <option key={index} value={item.sprint_log_project_id}>{item.tc_code}</option>
            ))}
          </select>

        </div>

        <div className='w-full h-full py-2'>
          <input
            type="text"
            name="email"
            id="email"
            placeholder='Related Page'
            className="block w-full rounded-md border-0 px-3.5 py-4 bg-white text-gray-900 shadow-sm placeholder:text-gray-400 sm:text-sm sm:leading-6"
          />
        </div>

        <div className='w-full h-full py-2'>
          <input
            type="text"
            name="email"
            id="email"
            placeholder='Issue Detail'
            className="block w-full rounded-md border-0 px-3.5 py-4 bg-white text-gray-900 shadow-sm placeholder:text-gray-400 sm:text-sm sm:leading-6"
          />

        </div>

        <div className='w-full h-full py-2'>
          <select id="countries" class="bg-white border border-bg-primary text-gray-900 text-sm rounded-lg focus:border-blue-500 block w-full p-4 dark:focus:border-blue-500">
            <option value={''}>Status</option>
            <option value="ok">OK</option>
            <option value="notok">NOT OK</option>
          </select>

        </div>

        <div className='w-full h-full py-2'>
          <input
            type="text"
            name="email"
            id="email"
            placeholder='Comments'
            className="block w-full rounded-md border-0 px-3.5 py-4 bg-white text-gray-900 shadow-sm placeholder:text-gray-400 sm:text-sm sm:leading-6"
          />

        </div>
        <div className='flex justify-center w-full h-full py-2'>
          <a href='/home' className="px-8 py-2 bg-white rounded-full">
            + Tambah Laporan
          </a>
        </div>
        <div className='w-full h-full py-2'>
          <a href='/home' className="block px-8 py-4 text-sm font-semibold text-center text-white rounded-full shadow-sm bg-gradient-to-b from-red-light-bg to-orange-bg hover:bg-gradient-to-b hover:from-red-dark-bg hover:to-orange-dark-bg hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
            SIMPAN
          </a>
        </div>


      </div>




    </div >
  )
}

export default LaporanKerja